import DataTable from "react-data-table-component";

// Eliminada la interfaz RowItem

const TableCompanies = ({
    data,
    // selectedCompany,
    // onCompanySelect
}) => {

    // Eliminado el tipo TableColumn<RowItem>[]
    const columns = [
        // {
        //     name: "",
        //     cell: row => {
        //         const isSelected = selectedCompany === row.name;
        //         const isAnotherSelected = selectedCompany !== null && !isSelected;

        //         return (
        //             <input
        //                 type="checkbox"
        //                 checked={isSelected}
        //                 disabled={isAnotherSelected}
        //                 onChange={() => onCompanySelect(row.name)}
        //             />
        //         );
        //     },
        //     width: "70px",
        //     center: true
        // },
        {
            name: "Empresa",
            selector: row => row.name,
            sortable: true,
        },
        {
            name: "Tipo de empresa",
            selector: row => row.company_type,
            sortable: true,
        },
        {
            name: "Cantidad de reportes",
            selector: row => row.quantity,
            sortable: true,
            center: true
        },
        {
            name: "Meses reportados",
            cell: row => (
                <div>
                    {row.month_report.length === 0
                        ? "SIN REPORTES"
                        : row.month_report
                            .map(date => {
                                const [year, month] = date.split("-");
                                return new Date(year, month - 1, 1)
                                    .toLocaleDateString("es-ES", {
                                        year: "numeric",
                                        month: "short"
                                    });
                            })
                            .join(", ")
                            .toUpperCase()
                    }
                </div>
            ),
            grow: 2
        }


    ];

    return (
        <DataTable
            title=""
            noDataComponent="No hay registros para mostrar"
            columns={columns}
            data={data}
            pagination
            highlightOnHover
            striped
            responsive
        />
    );
}

export default TableCompanies;